import { TableContainer } from '@mui/material';
import styled from 'styled-components';

import DashboardStudentTable from './DashboardStudentTable';
import DashboardSessionSelect from '../DashboardSessionSelect';

const ViewContainer = styled.div`
    margin: 12px;
`;

const ClassTableContainer = styled(TableContainer)`
    margin-top: 12px;
`;

const DashboardStudentView: React.FC = () => (
    <ViewContainer>
        <DashboardSessionSelect />
        <ClassTableContainer>
            <DashboardStudentTable />
        </ClassTableContainer>
    </ViewContainer>
);

export default DashboardStudentView;
